import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { adminbookingsResponse, Admins, AllTransactions, FinanceOverviewData, landlordDetails, ListingOverview, OverViewResponse } from "./interface";


interface IAdminState {
bookingOverview: OverViewResponse | null;
allBookings: adminbookingsResponse | null;
financeOverview:FinanceOverviewData|null;
allTransactions:AllTransactions[]|null;
listingOverview:ListingOverview|null;
admins:Admins[]|null;
landlordDetails: landlordDetails | null;

}
const initialState: IAdminState = {
bookingOverview: null,
allBookings: null,
financeOverview:null,
allTransactions:null,
listingOverview:null,
admins:null,
landlordDetails: null
}
export const AdminSlice = createSlice({
    name: "admin",
    initialState,
    reducers:{
        setBookingOverview: (state, action:PayloadAction<OverViewResponse>) => {
            state.bookingOverview = action.payload;
        },
    setAllBookings: (state, action:PayloadAction<adminbookingsResponse>) => {
            state.allBookings = action.payload;
        },
        setFinanceOverview: (state, action:PayloadAction<FinanceOverviewData>)=>{
            state.financeOverview = action.payload;
        },
        setAllTransactions: (state, action:PayloadAction<AllTransactions[]>)=>{
            state.allTransactions = action.payload;
        },
        setListingOverview: (state, action:PayloadAction<ListingOverview>)=>{
            state.listingOverview = action.payload;
        },
        setAdmins: (state, action:PayloadAction<Admins[]>)=>{
            state.admins = action.payload;
        },
        setLandlordDetails: (state, action:PayloadAction<landlordDetails>)=>{
            state.landlordDetails = action.payload;

        }
    }
})

export const {
    setAdmins,
    setAllBookings,
    setAllTransactions,
    setBookingOverview,
    setFinanceOverview,
    setListingOverview,
    setLandlordDetails
} = AdminSlice.actions;